export const pageTitle = (title) => {
  return (document.title = "Idealign  - " + title);
};
